import {ASync} from "../PA.Core/Basic/ASync";
import {IPolicy} from "../PA.Core/PA.Core.IF.Policy";
import {BehaviorSubject} from "rxjs";
import * as _ from 'lodash'
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {IUsrContext} from "../PA.Core/PA.Core.IF.User";
import {Role_TPM_Claim_Approver, Role_TPM_Claim_Editor} from "../PA.Core/Security/Roles";
import {ClaimBO} from "./ClaimBO";
import {WB_ClaimTypeRow} from "../PA.Core/PAdbSchemaRows";

export class ClaimBOStandardPolicy
    implements
        IPolicy
{
    _Claim: ClaimBO
    _ClaimType: WB_ClaimTypeRow
    _PolicyChanged: BehaviorSubject<IPolicy>
    _isApprover: boolean
    _isEditor: boolean
    _isClosedOrCancelled: boolean
    _isPostApproval: boolean
    _isPreApproval: boolean
    _isLoaded: boolean

    constructor(Claim: ClaimBO) {
        this._Claim = Claim
        this._ClaimType = Claim.WB_Claim.WB_ClaimTypeRow
        this._PolicyChanged = new BehaviorSubject<IPolicy>(this)
        this._isApprover = false
        this._isEditor = false
        this._isClosedOrCancelled = false
        this._isPostApproval = false
        this._isPreApproval = false
        this._isLoaded = false
    }

    get OnLoadComplete(): Promise<void> {
        const self = this

        if(self._isLoaded){ return ASync.resolve() }
        let wbCustomerId = 0
        return new Promise<void>((resolve, error) => {
            self._Claim.OnLoadComplete
                .then((ignore:any) => {
                    wbCustomerId = self._Claim.WB_Claim.cif.WB_CUST_ID_CLAIM || self._Claim.WB_Claim.cif.WB_CUST_ID_PLANNING
                    let currentState = self._Claim.PrimaryWorkflowProcessor.CurrentState
                    self._isClosedOrCancelled =  currentState.StatusTypeClosed || currentState.StatusTypeCancelled
                    self._isPostApproval = currentState.StatusTypeIsPostApproval
                    self._isPreApproval = currentState.StatusTypeIsPreApproval

                    let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)

                    if(!wbCustomerId && usrContext){
                        // A user-created claim has no Planning/Claim customer assigned yet, so there
                        // is no specific customer to check the role against.
                        self._isEditor = usrContext.hasRoleIdForAnyCustomer(Role_TPM_Claim_Editor)
                        self._isApprover = false
                    } else if(usrContext){
                        let wbSalesOrgId = self._Claim.WB_Claim.cif.WB_SALESORG_ID
                        let bInSalesOrg = _.some(usrContext.WB_SalesOrgs, (aSalesOrg) => aSalesOrg.cif.WB_SALESORG_ID === wbSalesOrgId)
                        let bCanAccessCustomer = _.some(usrContext.Customers, (aCustomer) => aCustomer.cif.WB_CUST_ID === wbCustomerId)

                        if(bInSalesOrg && bCanAccessCustomer){
                            self._isEditor =  usrContext.hasRoleId(Role_TPM_Claim_Editor, wbCustomerId)
                            self._isApprover = usrContext.hasRoleId(Role_TPM_Claim_Approver, wbCustomerId)
                        } else {
                            self._isApprover = false
                            self._isEditor = false
                        }
                    } else {
                        self._isApprover = false
                        self._isEditor = false
                    }
                    self._isLoaded = true
                    self._PolicyChanged.next(self)
                })
                .catch((err:any) => {
                    self._isApprover = false
                    self._isEditor = false
                    self._PolicyChanged.next(self)
                })
            //
            resolve()
        })
    }

    get bIsApprover(): boolean {
        return this._isApprover
    }

    get bIsEditor(): boolean {
        return this._isEditor
    }

    get bIsClosedOrCancelled(): boolean {
        return this._Claim.PrimaryWorkflowProcessor.CurrentState.StatusTypeClosed|| this._Claim.PrimaryWorkflowProcessor.CurrentState.StatusTypeCancelled
    }

    get bIsPreApproval(): boolean {
        return this._isPreApproval
    }

    get bIsPostApproval(): boolean {
        return this._isPostApproval
    }

    get bNameEditable(): boolean{
        return this.bIsEditor && !this.bIsClosedOrCancelled
    }

    get bPlanningCustomerVisible(): boolean{
        return this._ClaimType.cif.PLANNING_CUST_SHOW_IND=='1'?true:false
    }

    get bFundingCustomerVisible(): boolean{
        return this._ClaimType.cif.CLAIM_CUST_SHOW_IND=='1'?true:false
    }

    get bReasonCodeVisible():boolean{
        return this._ClaimType.cif.REASON_CODE_SHOW_IND=='1'?true:false
    }

    get bInvoiceVisible():boolean{
        return this._ClaimType.cif.CUSTOMER_INVOICE_SHOW_IND=='1'?true:false
    }

    get bWorkflowHistoryTabVisible(): boolean {
        return this.bIsPostApproval || this.bIsClosedOrCancelled
    }

    get bIsEditable():boolean{
        return this._ClaimType.cif.CREATE_POLICY=='UserCreation'?true:false
    }

    get PolicyChanged(): BehaviorSubject<IPolicy> {
        return this._PolicyChanged
    }

}


